import React from 'react';

import clsx from 'clsx';

import { Select, Stack, Typography, makeStyles } from '@gogame/components';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'block',
    color: theme.palette.primary.main,
    '& > div:first-child': {
      borderRadius: 16,
      color: theme.palette.primary.main,
      '& div': {
        borderRadius: 16,
        paddingTop: 3,
        paddingLeft: 8,
        paddingBottom: 3,
      },
    },
  },
  selected: {
    '& > div:first-child': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const EventNumber = ({
  name = '',
  selected,
  elements,
  onChange,
  favouriteMetricName,
  value,
}) => {
  const classes = useStyles();
  const placeholder = elements?.length
    ? `${elements[0].name} - ${elements[elements.length - 1].name}`
    : '';
  const handleChange = ({ target: { value } }) => {
    onChange(value ? `${favouriteMetricName} ${value}` : favouriteMetricName);
  };
  return (
    <Stack spacing={1} style={{ margin: '16px 0' }}>
      <Typography variant={'caption'} color={'textSecondary'}>
        {name}
      </Typography>
      <Select
        className={clsx(classes.root, {
          [classes.selected]: selected,
        })}
        options={elements}
        onChange={handleChange}
        value={value}
        placeholder={placeholder}
        canDeselect
      />
    </Stack>
  );
};

export default EventNumber;
